/* eslint-disable no-new-wrappers */
import React, { useEffect, useState } from 'react'

import useUserInvitations from '../../hooks/userInvitations/useUserInvitationsApi'
import DeleteConfirmationModal from '../common/DeleteConfirmationModal'
import { userTypes } from '../../utils/constants'
import { useIsSecurityUser } from '../../hooks/useIsSecurityUser'
import CustomTable from '../customTable/CustomTable'
import ShowImageTable from '../common/ShowImageTable'
import { useHistory } from 'react-router-dom'
import GuestForm from './GuestForm'
import Modal from '@material-ui/core/Modal'
import ListHeader from '../common/ListHeader'
import { paths } from '../../utils/paths'
import useNotificationsApi from '../../hooks/notifications/useNotificationsApi'
import { formatInvitationOrigin } from '../../utils/invitationOrigin'

const scheduleTypes = { recurring: 'recurring', oneTime: 'one_time' }

export default function GuestList({ building, loggedUser, type }) {
  const isSecurityUser = useIsSecurityUser()

  const history = useHistory()
  const [selectedInvitationToDelete, setSelectedInvitationToDelete] =
    useState(null)
  const [addInvitationModal, setAddInvitationModal] = useState(false)
  const [
    { userInvitationState },
    {
      getInvitations,
      deleteInvitation,
      createUserInvitation,
      resendInvitation,
    },
  ] = useUserInvitations()
  const [{ notificationsState }, { getServiceTypes }] = useNotificationsApi()

  useEffect(() => {
    const fetchServiceTypes = () => getServiceTypes()
    fetchServiceTypes()
  }, [])

  const columns = [
    {
      id: 'selfie',
      label: 'Persona',
      minWidth: 250,
      format: (value) => (
        <ShowImageTable
          imageUrl={value.selfie}
          name={`${value.firstName} ${value.lastName}`}
          ci={value.ci}
        ></ShowImageTable>
      ),
    },
    // {
    //   id: 'name',
    //   label: 'Nombre',
    //   minWidth: 170,
    //   format: (value) => `${value.firstName} ${value.lastName}`,
    // },
    // { id: 'ci', label: 'CI', minWidth: 50 },
    {
      id: 'building',
      label: isSecurityUser ? 'Unidades' : 'Cliente/Unidad',
      minWidth: 170,
      format: (value) => getClientOrApartments(value),
    },
    {
      id: 'creator',
      label: 'Creado por',
      minWidth: 150,
      format: (value) => formatInvitationOrigin(value) || ' - ',
    },
    !isSecurityUser
      ? {
          id: 'email',
          label: 'Email',
          minWidth: 170,
        }
      : {},
    {
      id: 'schedules',
      label: 'Horarios',
      minWidth: 170,
      format: (value) => {
        return value.schedules.map((schedule) => {
          const startTime = new Date(schedule.startTime)
          const endTime = new Date(schedule.endTime)
          const dateOptions =
            schedule.type === scheduleTypes.oneTime
              ? {
                  day: '2-digit',
                  month: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                }
              : {
                  hour: '2-digit',
                  minute: '2-digit',
                }
          return (
            <div
              style={{
                display: 'flex',
                marginTop: '5px',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              {circleDaysIcons(schedule.days)}
              <div>
                <span>
                  {`${startTime.toLocaleString(
                    'es-UY',
                    dateOptions
                  )} - ${endTime.toLocaleString('es-UY', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}`}
                </span>
              </div>
            </div>
          )
        })
      },
    },
    {
      id: 'phone',
      label: 'Telefono',
      minWidth: 170,
    },
    {
      id: 'observations',
      label: 'Obs.',
      minWidth: 170,
    },
    {
      id: '',
      label: '',
      minWidth: 5,
    },
  ]

  const formatUnderscore = (value) => {
    return (
      value?.replaceAll('_', ' ').toUpperCase().charAt(0) +
      value?.replaceAll('_', ' ').slice(1)
    )
  }

  if (type === 'services') {
    const selfieIndex = columns.findIndex((column) => column.id === 'selfie')
    columns.splice(selfieIndex + 1, 0, {
      id: 'company',
      label: 'Empresa',
      minWidth: 170,
    })
    columns.splice(0, 0, {
      id: 'serviceType',
      label: 'Tipo de servicio',
      format: (value) =>
        value.serviceType
          ? formatUnderscore(value.serviceType)
          : 'No especifica',
      minWidth: 170,
    })
  }

  const options = (invitation) => [
    {
      key: 'resend',
      label: 'Reenviar',
      onClick: () => {
        resendInvitation(invitation.id)
      },
    },
    ...[
      {
        key: 'edit',
        label: 'Editar',
        onClick: () => {
          history.push('/nuevo-invitado', {
            invitation,
            type,
            pathOverride: type === 'services' ? paths.SERVICES : paths.GUESTS,
            building,
          })
        },
      },
    ],
    {
      key: 'delete',
      label: 'Eliminar',
      onClick: () => {
        setSelectedInvitationToDelete(invitation)
      },
    },
  ]

  const circleDaysIcons = (days) => {
    if (!days) return <div>Sin configuracion</div>
    const Circle = ({ day }) => (
      <div
        style={{
          width: '20px',
          height: '20px',
          backgroundColor: 'green',
          borderRadius: '100%',
          alignItems: 'center',
          textAlign: 'center',
          marginRight: '5px',
          fontSize: '10px',
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {day}
      </div>
    )

    return (
      <div style={{ display: 'flex' }}>
        {days[0] === '1' && <Circle day="D"></Circle>}
        {days[1] === '1' && <Circle day="L"></Circle>}
        {days[2] === '1' && <Circle day="M"></Circle>}
        {days[3] === '1' && <Circle day="X"></Circle>}
        {days[4] === '1' && <Circle day="J"></Circle>}
        {days[5] === '1' && <Circle day="V"></Circle>}
        {days[6] === '1' && <Circle day="S"></Circle>}
      </div>
    )
  }

  const getClientOrApartments = (invitation) => {
    if (invitation.isGeneralService) {
      return invitation?.building?.name
    }
    if (invitation?.apartments?.length === 0) {
      return '-'
    }
    if (isSecurityUser && invitation?.apartments) {
      return invitation?.apartments.length > 3
        ? `${invitation?.apartments
            .slice(0, 3)
            .map((ap) => ap.name)
            .join(' / ')} ...`
        : invitation?.apartments.map((ap) => ap.name).join(' / ')
    } else {
      if (invitation?.apartments === null) {
        return invitation?.building?.name
      }
      return invitation?.building?.apartments?.length > 3
        ? `${invitation?.name}/${invitation?.apartments
            ?.slice(0, 3)
            ?.map((ap) => ap.name)
            .join(' / ')} ...`
        : `${invitation?.building?.name}/${invitation?.apartments
            ?.map((ap) => ap.name)
            .join(' / ')}`
    }
  }

  const serviceTypeOptions = notificationsState?.serviceTypes
    ? [
        { label: 'Todos', value: 'all' },
        ...notificationsState?.serviceTypes?.map((type) => ({
          label: formatUnderscore(type.name),
          value: type.id,
        })),
      ]
    : [{ label: 'Todos', value: 'all' }]

  return (
    <>
      <ListHeader
        bigTitle={
          type === 'services'
            ? 'Servicios'
            : 'Visitas autorizadas por residentes'
        }
        createText={type === 'services' ? 'Nuevo servicio' : 'Nueva visita'}
        canCreate={
          loggedUser?.type === userTypes.security ||
          loggedUser?.type === userTypes.admin
        }
        createRedirect={() =>
          history.push('/nuevo-invitado', {
            type,
            pathOverride: type === 'services' ? paths.SERVICES : paths.GUESTS,
          })
        }
      />
      <CustomTable
        loading={userInvitationState.isLoading}
        columns={columns}
        data={userInvitationState?.invitations?.data || []}
        getData={(params) =>
          getInvitations({
            ...params,
            showSelfie: true,
            serviceType:
              params.serviceType === 'all' ? null : params.serviceType,
          })
        }
        buildingFilter={!building}
        building={building}
        apartmentFilter={true}
        searchTitle={'Nombre, apellido, documento o empresa'}
        searchPlaceholder={'Ingrese un nombre, apellido, documento o empresa'}
        options={options}
        serverPagination={true}
        serverCount={userInvitationState?.invitations?.count}
        customFilters={[
          {
            field: 'status',
            label: 'Estado',
            type: 'select',
            options: [
              { value: 'completed', label: 'Completado' },
              { value: 'incompleted', label: 'Incompleto' },
              { value: 'schedulesSelected', label: 'Horarios asignados' },
            ],
            withRightMargin: true,
          },
          ...(type === 'services'
            ? [
                {
                  label: 'Tipo',
                  type: 'select',
                  field: 'serviceType',
                  options: serviceTypeOptions,
                },
              ]
            : []),
        ]}
      ></CustomTable>
      <DeleteConfirmationModal
        open={!!selectedInvitationToDelete}
        invitation={selectedInvitationToDelete}
        onClose={() => setSelectedInvitationToDelete(null)}
        onDelete={(invitation) => {
          deleteInvitation(invitation.id)
          setSelectedInvitationToDelete(null)
        }}
      />
      <Modal
        open={addInvitationModal}
        onClose={() => setAddInvitationModal(false)}
        aria-labelledby="simple-modal-title"
        disableScrollLock
        sx={{ height: '200vh', overflow: 'scroll' }}
      >
        <GuestForm
          building={building}
          handleCancel={() => setAddInvitationModal(false)}
          afterSubmit={() => {
            setAddInvitationModal(false)
          }}
          createUserInvitation={createUserInvitation}
        ></GuestForm>
      </Modal>
    </>
  )
}
